import { LoaderFunctionArgs, redirect, useLoaderData } from "react-router";
import routes from "#lib/routes";
import { KemonoLink } from "#components/links";
import { getArtist, IArtistDetails, ProfileHeader, Tabs } from "#entities/profiles";
import { CommunityChannel, fetchCommunityChannelList } from "#lib/api/community-channels";
import { ProfilePageSkeleton } from "#components/pages";
import { CardList } from "#components/cards";

import * as styles from "./community-channel-index.module.scss";
import { Timestamp } from "#components/dates";
import clsx from "clsx";

interface IProps {
  creator: IArtistDetails;
  channels: CommunityChannel[];
}

export function CommunityChannelIndex() {
  const { creator, channels } = useLoaderData<IProps>();
  const title = `${creator.name}'s Community Channels`;

  if (!channels.length) {
    return <>No results found.</>;
  }

  return (
    <ProfilePageSkeleton name="user" title={title} profile={creator}>
      <ProfileHeader service="patreon" profileID={creator.id} profileName={creator.name} />

      {/* Paginator shouldn't be necessary here, but Tabs styles are inherited from it. */}
      <div className="paginator">
        <Tabs
          currentPage="community"
          service="patreon"
          artistID={creator.id}
        />
      </div>

      <CardList>
        {channels.map(channel =>
          <article key={channel.channel_id} className={clsx(styles.card, "user-card")}>
            <KemonoLink url={routes.communityChannel(creator.id, channel.channel_id)}>
              <main>
                {channel.name}
              </main>
              {channel.messages_refreshed_at && (
                <footer>
                  Updated: <Timestamp time={channel.messages_refreshed_at} />
                </footer>
              )}
            </KemonoLink>
          </article>
        )}
      </CardList>
    </ProfilePageSkeleton>
  );
}


export async function loader({ params }: LoaderFunctionArgs): Promise<IProps | Response> {
  const creatorId = params.creatorId!;
  const profile = getArtist("patreon", creatorId);
  const channels = await fetchCommunityChannelList(creatorId);

  if (channels.length == 1) {
    return redirect(routes.communityChannel(creatorId, channels[0].channel_id));
  }

  return {
    creator: await profile,
    channels,
  }
}
